import React from 'react';
import Hero from '../../components/pages/Infrastructure/Hero/Hero';
import Protocols from '../../components/pages/Infrastructure/Protocols/Protocols';
import Operational from '../../components/pages/Infrastructure/Operational/Operational';
import Global from '../../components/pages/Infrastructure/Global/Global';
import NeverStatic from '../../components/pages/Infrastructure/NeverStatic/NeverStatic';
import BankOn from '../../components/pages/Infrastructure/BankOn/BankOn';

const Infrastructure = () => {
  return (
    <div>
      <Hero />
      <Protocols />
      <Operational />
      <Global />
      <NeverStatic />
      <BankOn />
    </div>
  );
};

export default Infrastructure;
